import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSystemConfig, updateSystemConfig } from "@/api/management/system";
import { getLoginConfig as _getLoginConfig } from "@/api/login";
import { sysFileUpload } from "@/api/managementCenter/otherApi";
export default {
  data: function data() {
    return {
      form: {
        logo_text: "",
        favicon: "",
        copyright_info: "",
        logo: "",
        ssoLogin: "",
        ssoLogout: "",
        isOpenCassso: false,
        middlePage: false,
        phone: false,
        mobileOrPc: false,
        mobileUrl: "",
        pcUrl: ""
      },
      tableData: [],
      fileList: [],
      imageUrl: "",
      logoList: [],
      iconUrl: ""
    };
  },
  mounted: function mounted() {
    this.getSystemConfigInfo();
  },
  methods: {
    getSystemConfigInfo: function () {
      var _getSystemConfigInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var _yield$getSystemConfi, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getSystemConfig();

              case 2:
                _yield$getSystemConfi = _context.sent;
                data = _yield$getSystemConfi.data;

                if (data.success) {
                  this.tableData = data.data;
                  this.tableData.forEach(function (i) {
                    if (i.values) {
                      i.values = JSON.parse(i.values);
                    } //图标回显


                    if (i.type == "3" && i.value) {
                      _this.iconUrl = i.value;
                    } //logo回显


                    if (i.type == "1" && i.value != "") {
                      _this.imageUrl = i.value;
                    }
                  });
                  console.log(this.tableData);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSystemConfigInfo() {
        return _getSystemConfigInfo.apply(this, arguments);
      }

      return getSystemConfigInfo;
    }(),
    edit: function () {
      var _edit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val) {
        var obj, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                obj = JSON.parse(JSON.stringify(val));

                if (obj.values != "") {
                  obj.values = JSON.stringify(val.values);
                }

                _context2.next = 4;
                return updateSystemConfig(obj);

              case 4:
                res = _context2.sent;

                if (res.data.success) {
                  this.getLoginConfig();
                  this.$message.success("保存成功!");
                } else {
                  this.$message.warning(res.data.msg || "保存失败!");
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function edit(_x) {
        return _edit.apply(this, arguments);
      }

      return edit;
    }(),
    getLoginConfig: function () {
      var _getLoginConfig2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, faviconLink;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _getLoginConfig();

              case 2:
                res = _context3.sent;
                res.data.data.isOpenCassso == "1" ? res.data.data.isOpenCassso = true : res.data.data.isOpenCassso = false;
                res.data.data.middlePage == "1" ? res.data.data.middlePage = true : res.data.data.middlePage = false;
                res.data.data.phone == "1" ? res.data.data.phone = true : res.data.data.phone = false;
                res.data.data.mobileOrPc == "1" ? res.data.data.mobileOrPc = true : res.data.data.mobileOrPc = false;
                window.sessionStorage.setItem("setConfig", JSON.stringify(res.data.data));
                faviconLink = document.querySelector("#faviconLink");

                if (faviconLink) {
                  faviconLink.setAttribute("href", res.data.data.favicon);
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getLoginConfig() {
        return _getLoginConfig2.apply(this, arguments);
      }

      return getLoginConfig;
    }(),
    beforeRemove: function beforeRemove(file, fileList) {
      this.fileList = fileList;
    },
    beforeUpload: function beforeUpload(file) {
      var _this2 = this;

      this.fileList = [];
      var isICON = file.type === "image/x-icon";

      if (!isICON) {
        this.$message.error("上传图标只能是icon格式!");
        return;
      }

      var fd = new FormData();
      fd.append("file", file);
      sysFileUpload(fd).then(function (_ref) {
        var data = _ref.data;
        console.log(data);

        if (data.success) {
          _this2.iconUrl = data.data.url;

          _this2.tableData.forEach(function (i) {
            if (i.type == "3") {
              i.value = data.data.url;
            }
          });

          _this2.$message.success("上传成功!");
        } else {
          _this2.$message.warning(data.msg || "上传失败!");
        }
      });
    },
    //学院logo
    beforeUploadlogo: function beforeUploadlogo(file) {
      var _this3 = this;

      this.imageUrl = "";
      var isJPG = file.type === "image/jpeg" || file.type === "image/png";

      if (!isJPG) {
        this.$message.error("上传图标只能是JPG/PNG格式!");
        return;
      }

      var fd = new FormData();
      fd.append("file", file);
      sysFileUpload(fd).then(function (_ref2) {
        var data = _ref2.data;
        console.log(data);

        if (data.success) {
          _this3.imageUrl = data.data.url;

          _this3.tableData.forEach(function (i) {
            if (i.type == "1") {
              i.value = data.data.url;
            }
          });

          _this3.$message.success("上传成功!");
        } else {
          _this3.$message.warning(data.msg || "上传失败!");
        }
      });
    },
    beforeRemoveLogo: function beforeRemoveLogo() {}
  }
};